import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import $ from 'jquery';
import { connect } from 'react-redux';

import SettingsComponent from '../../components/settings/settingsComponent';


class SettingsContainer extends Component {

    constructor(props){
        super(props);
    }

    render(){
        return(
            null
            /*   <SettingsComponent   /> */
        )
    }
}







  export default SettingsContainer; 







// WEBPACK FOOTER //
// ./src/containers/settings/settingsContainer.js